import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useFeatures } from "../context/FeatureContext";
import { Home, Users, FlaskConical, FileText, Pill } from "lucide-react";

export default function MobileBottomNav({ onBookClick }) {
  const { hiddenPath } = useFeatures();
  const location = useLocation();
  const isActive = (path) => location.pathname === path;

  return (
    <div 
      data-testid="persistent-mobile-bottom-nav"
      className="xl:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#07221A] border-t border-[#165644] px-1 py-1.5 shadow-2xl grid grid-cols-5 items-center text-gray-400 no-print"
    >
      <Link 
        to="/" 
        data-testid="mobile-tab-home"
        className={`flex flex-col items-center justify-center p-1 min-w-0 w-full text-[10px] leading-tight text-center font-medium transition-colors ${isActive('/') ? 'text-amber-300' : 'hover:text-gray-200'}`}
      >
        <Home className="w-4 h-4 mb-0.5" />
        <span className="truncate max-w-full">Home</span>
      </Link>

      {!hiddenPath("/doctors") && <Link 
        to="/doctors" 
        data-testid="mobile-tab-doctors"
        className={`flex flex-col items-center justify-center p-1 min-w-0 w-full text-[10px] leading-tight text-center font-medium transition-colors ${isActive('/doctors') ? 'text-amber-300' : 'hover:text-gray-200'}`}
      >
        <Users className="w-4 h-4 mb-0.5" />
        <span className="truncate max-w-full">Doctors</span>
      </Link>}


      {!hiddenPath("/diagnostics") && <Link 
        to="/diagnostics" 
        data-testid="mobile-tab-tests"
        className={`flex flex-col items-center justify-center p-1 min-w-0 w-full text-[10px] leading-tight text-center font-medium transition-colors ${isActive('/diagnostics') ? 'text-amber-300' : 'hover:text-gray-200'}`}
      >
        <FlaskConical className="w-4 h-4 mb-0.5" />
        <span className="truncate max-w-full">Tests</span>
      </Link>}

      {!hiddenPath("/medicines") && <Link 
        to="/medicines" 
        data-testid="mobile-tab-medicines"
        className={`flex flex-col items-center justify-center p-1 min-w-0 w-full text-[10px] leading-tight text-center font-medium transition-colors ${isActive('/medicines') ? 'text-amber-300' : 'hover:text-gray-200'}`}
      >
        <Pill className="w-4 h-4 mb-0.5" />
        <span className="truncate max-w-full">Medicines</span>
      </Link>}

      <Link 
        to="/my-health" 
        data-testid="mobile-tab-account"
        className={`flex flex-col items-center justify-center p-1 min-w-0 w-full text-[10px] leading-tight text-center font-medium transition-colors ${isActive('/my-health') ? 'text-amber-300' : 'hover:text-gray-200'}`}
      >
        <FileText className="w-4 h-4 mb-0.5" />
        <span className="truncate max-w-full">My Health</span>
      </Link>
    </div>
  );
}
